import { escapeHtml } from '../utils/escapeHtml.js';

// Genera l'HTML della tabella storico stagioni. Funzione pura, riusata da cartoline e Confronto.
function cell(v) {
  return v === null || v === undefined || v === '' ? '—' : v;
}

/**
 * @param {Array} seasons - stagioni { season, team, matches, fm, goals, assists, yellow, red }
 * @returns {string} HTML
 */
export function buildHistoryTableHTML(seasons) {
  if (!seasons || !seasons.length) {
    return '<p class="studio-history-empty">Nessuno storico disponibile</p>';
  }
  const rows = seasons.map((s) =>
    `<tr><td>${cell(s.season)}</td><td>${cell(s.team)}</td><td class="num">${cell(s.matches)}</td><td class="num">${cell(s.fm)}</td><td class="num">${cell(s.goals)}</td><td class="num">${cell(s.assists)}</td><td class="num">${cell(s.yellow)}</td><td class="num">${cell(s.red)}</td></tr>`
  ).join('');
  return `<table class="studio-history-table"><thead><tr><th>Stag.</th><th>Squadra</th><th>Pres</th><th>FM</th><th>Gol</th><th>Ass</th><th>Amm</th><th>Esp</th></tr></thead><tbody>${rows}</tbody></table>`;
}

/**
 * Genera l'HTML della tabella storico affiancata per il Confronto:
 * una colonna per giocatore, una riga per stagione (Fantamedia), più recente prima.
 * @param {Array<{name: string, seasons: Array}>} entries
 * @returns {string} HTML
 */
export function buildHistoryCompareTableHTML(entries) {
  if (!entries || !entries.length) {
    return '<p class="studio-history-empty">Nessuno storico disponibile</p>';
  }
  const slots = entries;
  const filled = slots.filter(Boolean);
  if (!filled.length) {
    return '<p class="studio-history-empty">Nessuno storico disponibile</p>';
  }
  const seasonSet = new Set();
  const seasonMaps = slots.map((entry) => {
    if (!entry) return null;
    const map = new Map();
    for (const s of entry.seasons || []) {
      map.set(s.season, s);
      seasonSet.add(s.season);
    }
    return map;
  });
  if (!seasonSet.size) {
    return '<p class="studio-history-empty">Nessuno storico disponibile</p>';
  }
  const seasons = Array.from(seasonSet).sort().reverse();
  const colgroup = `<colgroup><col class="studio-compare-table-label-col"><col span="${slots.length}" class="studio-compare-player-col"></colgroup>`;
  const head = `<tr><th class="studio-compare-table-label-col" scope="col">Stag.</th>${slots.map((e) => {
    if (!e) {
      return '<th class="studio-compare-player-col" scope="col" aria-hidden="true"></th>';
    }
    return `<th class="studio-compare-player-col num" scope="col">${escapeHtml(e.name)}</th>`;
  }).join('')}</tr>`;
  const body = seasons.map((season) => {
    const cells = seasonMaps.map((map) => {
      if (!map) {
        return '<td class="num studio-compare-cell--empty" aria-hidden="true"></td>';
      }
      const s = map.get(season);
      if (!s) return '<td class="num"><span class="studio-history-compare-cell studio-history-compare-cell--empty">—</span></td>';
      const team = s.team
        ? `<span class="studio-history-compare-team">${cell(s.team)}</span>`
        : '';
      return `<td class="num"><span class="studio-history-compare-cell"><span class="studio-history-compare-fm">${cell(s.fm)}</span>${team}</span></td>`;
    }).join('');
    return `<tr><th scope="row">${cell(season)}</th>${cells}</tr>`;
  }).join('');
  return `<div class="studio-compare-table-scroll"><table class="studio-compare-table studio-history-compare-table">${colgroup}<thead>${head}</thead><tbody>${body}</tbody></table></div>`;
}
